export const sideBarStyle = {
    isNotActiveStyle: 'flex items-center px-5 gap-3 text-gray-500 hover:text-black transition-all duration-200 ease-in-out capitalize',
    isActiveStyle: 'flex items-center px-5 gap-3 font-extrabold border-r-2 border-black  transition-all duration-200 ease-in-out capitalize',
    sideBar: 'flex flex-col justify-between bg-white h-full overflow-y-scroll min-w-210 hide-scrollbar',
    container: 'flex flex-col',
    categoryStyle: 'mt-2 px-5 text-base 2xl:text-xl',
    link: 'flex px-5 gap-2 my-6 pt-1 w-190 items-center',
    headerLink: 'flex flex-col gap-5',
    image: 'w-8 h-8 rounded-full shadow-sm',
    userLink: 'flex my-5 mb-3 gap-2 p-2 items-center bg-white rounded-lg shadow-lg mx-3',
    userImage: 'w-10 h-10 rounded-full',
}
